export type ShopPermissionMap = Record<string, "yes" | "no" | string>;

export function shopPerm(
  permissions: ShopPermissionMap | undefined,
  key: string
): boolean {
  return permissions?.[key] === "yes";
}

export function canReadModule(
  permissions: ShopPermissionMap | undefined,
  module: string
): boolean {
  return shopPerm(permissions, `shop.${module}.read`);
}
